
import React, { FC } from 'react';
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd/es/upload/interface';

const { Dragger } = Upload;

interface FileUploaderProps {
    accept: string;
    fileList: UploadFile[];
    onChange: (fileList: UploadFile[]) => void;
    disabled?: boolean;
    uploadText: string;
}

export const FileUploader: FC<FileUploaderProps> = ({
    accept,
    fileList,
    onChange,
    disabled,
    uploadText,
}) => {
    const handleUploadChange = ({ fileList }: { fileList: UploadFile[] }) => {
        onChange(fileList.slice(-1));
    };

    return (
        <Dragger
            accept={accept}
            beforeUpload={() => false}
            fileList={fileList}
            maxCount={1}
            onChange={handleUploadChange}
            onRemove={() => onChange([])}
            disabled={disabled}
            style={{
                padding: '20px 0',
                height: '160px',
                border: '1px dashed',
                borderRadius: '4px',
                marginBottom: '16px',
            }}
        >
            <p className="ant-upload-drag-icon">
                <UploadOutlined />
            </p>
            <p className="ant-upload-text">{uploadText}</p>
        </Dragger>
    );
};